export const GOOGLE_CALENDAR_DIRECT_URL = 'https://calendar.app.google/uRXac587SAi2JAeKA';

export const GOOGLE_CALENDAR_EMBED_URL =
  'https://calendar.google.com/calendar/appointments/schedules/AcZssZ0ABr-19lICaMBwfRWj4G9lh5eStZnMf-uWpL2-VYUsk46nxERiSGW-45OqfiUP6hkSk2NNhUPJ?gv=true';
